exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".readmore[data-v-5d7e1e86]{max-width:30rem;text-align:center;padding:.5rem;border:1px solid #ddd;background:hsla(0,0%,100%,.11);color:#1f6dc6;display:block;border-radius:5px;margin:1.5rem auto;font-size:1.1rem;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;box-shadow:0 3px 10px 2px rgba(0,0,0,.1)}.readmore__external[data-v-5d7e1e86]{position:absolute;right:0;padding:0 10px;height:100%;top:0;display:flex;align-items:center;border-left:1px solid #577f40}.readmore__external a[data-v-5d7e1e86]{color:#577f40}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-5d7e1e86","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/custom/readmore.vue
// module id = 232
// module chunks = 1